import React from "react"
import "./valuationBlock.scss"
import ReactMarkdown from "react-markdown"
import {Col, Row, Container } from 'react-bootstrap';

const ValuationBlock =(props) => {       
  return (
    <div className="valuation-block-section">
      <div className="valuation-block__title">
        {props.title_content ? <ReactMarkdown source={props.title_content} allowDangerousHtml /> : '' }
      </div>
      <div className="valuation-block__content">
        <Container>
          <Row>
            {props.valuation_blocks.map((block, i) => {
                return (
                  <Col lg={6}>
                    <div className={`valuation-item ${i}`}>
                      <h2>{block.Title}</h2>
                      <ReactMarkdown source={block.Content} allowDangerousHtml />
                      {block.CTA_Link ? (<a href={block.CTA_Link} target={"_blank"} className="btn" > {block.CTA_Label}  </a>) : ''}
                    </div>
                  </Col>
                  )
            })}
          </Row>
        </Container>
      </div>
    </div>
  );
}
export default ValuationBlock;
